import { Button, Card, Flex, Space } from 'antd';

function PasswordResetedDesktop({ viewModel }) {
  const { token, goLogin } = viewModel;

  return (
    <Card style={{ width: '500px', position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}>
      <Flex vertical gap={14}>
        <Space direction="vertical" align="center">
          <img alt="sipro-logo" width={200} style={{ borderRadius: '8px' }} src="https://storage.googleapis.com/cubebio/default/siprologo.png" />
          <span style={{ fontSize: token.fontSizeHeading3, fontWeight: '500' }}>Mật khẩu của bạn đã được đặt lại</span>
          <Flex align="center" justify="center">
            <Space direction="vertical">
              <span>Vui lòng đăng nhập hệ thống</span>
              <Flex align="center" justify="center">
                <Button type="primary" onClick={goLogin}>
                  Login
                </Button>
              </Flex>
            </Space>
          </Flex>
        </Space>
      </Flex>
    </Card>
  );
}

export default PasswordResetedDesktop;
